import React from "react";
import { Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useTranslation } from "react-i18next";
import SettingsTab from "./tabs/SettingsTab";
import CodesTab from "./tabs/CodesTab";

const RuleForm = ({
  initialValues,
  onSave,
  onCancel,
  isAutoMode = false,
  hideCodesTab = false,
  isNew = false,
}) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = React.useState("settings");
  const [isCodeRequired, setIsCodeRequired] = React.useState(
    Boolean(initialValues?.isCodeRequired)
  );

  React.useEffect(() => {
    setIsCodeRequired(Boolean(initialValues?.isCodeRequired));
  }, [initialValues]);
  const handleSaveCodes = React.useCallback(
    (payload) => {
      const codes = (payload && payload.codes) || [];
      const base = initialValues || {};
      if (typeof onSave === "function") {
        onSave({ ...base, codes });
      }
    },
    [initialValues, onSave]
  );

  return (
    <Box sx={{ width: "100%" }}>
      <TabContext value={activeTab}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={(_, v) => setActiveTab(v)}>
            <Tab
              label={t("common.settings", { defaultValue: "Settings" })}
              value="settings"
            />
            {!hideCodesTab && (
            <Tab
              label={t("pages.dsokCartRules.codesTab", {
                defaultValue: "Codes",
              })}
              value="codes"
            />
            )}
          </TabList>
        </Box>
        <TabPanel value="settings" sx={{ p: 0 }}>
          <SettingsTab
            initialValues={initialValues}
            onSave={onSave}
            onCancel={onCancel}
            onIsCodeRequiredChange={setIsCodeRequired}
            isAutoMode={isAutoMode}
            isNew={isNew}
          />
        </TabPanel>
        {!hideCodesTab && (
        <TabPanel value="codes" sx={{ p: 0 }}>
          <CodesTab
            initialCodes={initialValues?.codes || []}
            onSave={handleSaveCodes}
            onCancel={onCancel}
          />
        </TabPanel>
        )}
      </TabContext>
    </Box>
  );
};

export default RuleForm;
